import {Menu, MenuItem} from '@material-ui/core'
import {RouteComponentProps} from '@reach/router'
import {useEffect, useState} from 'react'
import {MdArrowDropDown} from 'react-icons/md'
import {Box} from 'reoil'
import JobCard from '../components/JobsPage/JobCard'
import JobCardPC from '../components/JobsPage/JobCardPC'
import Navigation from '../components/Navigation'
import TabNav from '../components/TabNav'
import {MAX_WIDTH} from '../constants/media'
import useFetchJobs from '../hooks/api/useFetchJobs'
import useResponsive from '../hooks/useResponsive'
import {useJobsValue} from '../store/jobsState'
import localSave from '../utils/localSave'

const JobsPage: React.FC<RouteComponentProps> = () => {
  const [anchorCityEl, setAnchorCityEl] = useState<HTMLElement | null>(null)
  const [anchorTypeEl, setAnchorTypeEl] = useState<HTMLElement | null>(null)

  // 全局状态
  const jobs = useJobsValue()
  const {isWide} = useResponsive()

  // 城市
  const [cities, setCities] = useState<Array<string>>([
    '广州',
    '上海',
    '深圳',
    '香港',
    '澳门'
  ])
  const [selectedCity, setSelectedCity] = useState<string>(
    localSave.read('selectedCity')
  )

  // 岗位类别
  const [types, setTypes] = useState<Array<string>>([
    '内容采编类',
    '智库研究类',
    '技术类',
    '产品类',
    '运营推广类'
  ])
  const [selectedType, setSelectedType] = useState<string>(
    localSave.read('selectedType')
  )

  // 获取数据
  useFetchJobs()

  useEffect(
    function updateTypes() {
      setTypes(Array.from(new Set(jobs.map(item => item.posts).flat())))
      setCities(
        Array.from(
          new Set(jobs.map(item => item.locations.map(l => l.name)).flat())
        )
      )
    },
    [jobs]
  )

  // 更新 jobs 城市 岗位
  // useEffect(()=>{
  //   if(data) {
  //     setCities(Array.from(new Set(data.data.map(item=>item.locations.map(loc=>loc.name)).reduce((prev, cur)=>{
  //       return prev.concat(cur)
  //     }, []))))
  //     setTypes(Array.from(new Set(data.data.map(item=>item.posts.map(post=>post)).reduce((prev,cur)=>prev.concat(cur), []))))
  //   }
  // }, [data])

  // 筛选后的jobs
  const filteredJobs = jobs.filter(job => {
    let bool1: boolean = true
    let bool2: boolean = true
    if (selectedCity)
      bool1 = job.locations.some(item => item.name === selectedCity)
    if (selectedType) bool2 = job.posts.some(item => item === selectedType)
    return bool1 && bool2
  })

  const handleClickCity = (ev: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorCityEl(ev.currentTarget)
  }

  const handleClickType = (ev: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorTypeEl(ev.currentTarget)
  }

  useEffect(() => {
    setAnchorCityEl(null)
    setAnchorTypeEl(null)

    // 同步数据到localStorage
    localSave.set('selectedCity', selectedCity)
    localSave.set('selectedType', selectedType)
  }, [selectedCity, selectedType])

  return (
    <Box className='JobsPage' stretch pb={3}>
      <TabNav />
      <Navigation title='招聘岗位' />

      <Box className='filter' bg='white' p={3} row fontSize={1}>
        <Box maxWidth={MAX_WIDTH} fullWidth mx='auto' row>
          <Box row center flex={1} borderRight='divider'>
            <Box row onClick={handleClickCity} pointer>
              {selectedCity || '所在城市'}
              <MdArrowDropDown />
            </Box>
            <Menu
              anchorEl={anchorCityEl}
              open={Boolean(anchorCityEl)}
              onClose={() => setAnchorCityEl(null)}>
              <MenuItem
                value=''
                onClick={() => setSelectedCity('')}
                selected={!selectedCity}>
                全部
              </MenuItem>
              {cities.map(city => (
                <MenuItem
                  value={city}
                  key={city}
                  onClick={() => setSelectedCity(city)}
                  selected={selectedCity === city}>
                  {city}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box row center flex={1}>
            <Box row onClick={handleClickType} pointer>
              {selectedType || '岗位类别'}
              <MdArrowDropDown />
            </Box>
            <Menu
              anchorEl={anchorTypeEl}
              open={Boolean(anchorTypeEl)}
              onClose={() => setAnchorTypeEl(null)}>
              <MenuItem
                onClick={() => setSelectedType('')}
                selected={!selectedType}>
                全部
              </MenuItem>
              {types.map(type => (
                <MenuItem
                  value={type}
                  key={type}
                  onClick={() => setSelectedType(type)}
                  selected={type === selectedType}>
                  {type}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Box>
      </Box>

      <Box
        mt={2}
        p={2}
        borderBox
        stretch
        maxWidth={MAX_WIDTH}
        fullWidth
        mx='auto'>
        {isWide ? (
          <>
            <Box row px={3}>
              <Box
                flex={1}
                my={3}
                fontSize={1}
                fontWeight='bold'
                color='text.caption'>
                岗位名称
              </Box>
              <Box
                flex={1}
                my={3}
                fontSize={1}
                fontWeight='bold'
                color='text.caption'
                center>
                招聘单位
              </Box>
              <Box
                flex={1}
                my={3}
                fontSize={1}
                fontWeight='bold'
                color='text.caption'
                right>
                工作地点
              </Box>
            </Box>
            {filteredJobs.map((item, i) => (
              <JobCardPC
                key={item.id}
                title={item.title}
                id={item.id}
                posts={item.posts}
                locations={item.locations}
                company={item.company}
              />
            ))}
          </>
        ) : (
          filteredJobs.map((item, i) => (
            <JobCard
              key={item.id}
              title={item.title}
              id={item.id}
              posts={item.posts}
              locations={item.locations}
              company={item.company}
            />
          ))
        )}
      </Box>
      <Box center fontSize={0} py={3} color='text.caption'>
        没有更多咯 😭
      </Box>
    </Box>
  )
}

export default JobsPage
